import apiClient from '../client';

export interface PartNumberBreakdownRow {
  PartNumber: string;
  ReturnCount: number;
  RepairCount: number;
  TotalCount: number;
}

export interface CustomerBreakdownRow {
  CustomerName: string;
  ReturnCount: number;
  RepairCount: number;
  TotalCount: number;
}

export interface MonthlyReturnRow {
  Year: number;
  Month: number;
  RepairCount: number;
  ReturnCount: number;
}

export interface ReturnSummaryRow {
  Year: number;
  TotalRepairs: number;
  TotalReturns: number;
  TotalCombined: number;
}

export const returnsRepairsService = {
  getSummary: async (year1: number, year2: number): Promise<ReturnSummaryRow[]> => {
    const res = await apiClient.get('/returns-repairs/summary', { params: { year1, year2 } });
    return res.data;
  },

  getMonthlyCounts: async (year1: number, year2: number): Promise<MonthlyReturnRow[]> => {
    const res = await apiClient.get('/returns-repairs/monthly-counts', { params: { year1, year2 } });
    return res.data;
  },

  getPartNumberBreakdown: async (year: number, month: number, week = 0): Promise<PartNumberBreakdownRow[]> => {
    const res = await apiClient.get('/returns-repairs/part-numbers', { params: { year, month, week } });
    return res.data;
  },

  getCustomerBreakdown: async (year: number, month: number, week = 0, limit = 50): Promise<CustomerBreakdownRow[]> => {
    const res = await apiClient.get('/returns-repairs/customers', { params: { year, month, week, limit } });
    return res.data;
  },
};
